"use strict";

var qs = require('querystring');
var _require = require('./utils'),
  handleAjaxResponse = _require.handleAjaxResponse,
  sanitizeOptions = _require.sanitizeOptions;
var request = require('../../request');
module.exports = oAuth2CredentialsFlow;

/**
 * Trigger the OAuth2 credential flow using headers.
 * Reference: http://tools.ietf.org/html/rfc6749#section-4.4
 */
function oAuth2CredentialsFlow(options) {
  try {
    options = sanitizeOptions(options);
  } catch (error) {
    return Promise.reject(error);
  }
  if (typeof options.clientId !== 'string') {
    return Promise.reject(new TypeError('"clientId" expected'));
  }
  if (typeof options.clientSecret !== 'string') {
    return Promise.reject(new TypeError('"clientSecret" expected'));
  }
  if (typeof options.accessTokenUri !== 'string') {
    return Promise.reject(new TypeError('"accessTokenUri" expected'));
  }
  return new Promise(function (resolve, reject) {
    // Get the token by passing the client details in the auth header.
    request({
      url: options.accessTokenUri,
      proxy: options.proxy,
      xhr: options.xhr,
      method: 'POST',
      headers: {
        Accept: 'application/json, application/x-www-form-urlencoded',
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: "Basic ".concat(Buffer.from("".concat(options.clientId, ":").concat(options.clientSecret)).toString('base64'))
      },
      body: qs.stringify({
        grant_type: 'client_credentials'
      })
    }, function (err, xhr) {
      if (err) {
        reject(err);
        return;
      }
      try {
        resolve(handleAjaxResponse(xhr, options));
      } catch (error) {
        reject(error);
      }
    });
  });
}
//# sourceMappingURL=credentials.js.map